const useWebEngageCategoryClick = () => {
  const trackWebEngageCategoryClick = (categoryName: string) => {
    try {
      window.webengage.track("category_game_click", {
        Name: categoryName,
      });
    } catch (error) {
      console.log("🚀 ~ categoryClickWebEngage ~ error:", error);
    }
  };

  return { trackWebEngageCategoryClick };
};

export default useWebEngageCategoryClick;
